import { useState } from "react";
import { toast } from "react-toastify";
import { exportTaxonomicGroups } from "@services/taxonomicGroups/export";
import { exportToCSV, formatCSVData } from "@utils/export";
import { actualDateTime } from "@utils/formatters";
import { taxonomicGroupColumns } from "@typings/entities/taxonomicGroup";

export function useExportTaxonomicGroups() {
  const [isLoading, setIsLoading] = useState(false);

  const handleExport = async () => {
    setIsLoading(true);
    try {
      const response = await exportTaxonomicGroups();

      if (!response.items?.length) {
        toast.warning(
          "Nenhum dado de grupos taxonômicos disponível para exportar",
        );
        return;
      }

      const formattedData = formatCSVData(
        response.items,
        taxonomicGroupColumns,
      );
      exportToCSV(
        formattedData,
        `relatorio_grupos_taxonomicos-${actualDateTime()}`,
      );
      toast.success("Relatório de grupos taxonômicos exportado com sucesso!");
    } catch {
      toast.error("Erro ao exportar grupos taxonômicos");
    } finally {
      setIsLoading(false);
    }
  };

  return { handleExport, isLoading };
}
